/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { editProspects, getProspects } from "../../slices/formularioSlice";

export default function ModalEditProspect({
  isModalEdit,
  setIsModalEdit,
  prospect,
  errorMessage,
  success,
}) {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
    newIdea: "",
    namePodcast: "",
  });

  useEffect(() => {
    if (prospect) {
      setFormData({
        name: prospect.name,
        email: prospect.email,
        phone: prospect.phone,
        description: prospect.description,
        newIdea: prospect.newIdea,
        namePodcast: prospect.namePodcast,
      });
    }
  }, [prospect]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEditProspect = async (e) => {
    e.preventDefault();
    try {
      await dispatch(
        editProspects({ id: prospect._id, prospect: formData })
      ).unwrap();
      dispatch(getProspects());
      setIsModalEdit(false);
      success();
      setFormData({
        name: "",
        email: "",
        phone: "",
        description: "",
        newIdea: "",
        namePodcast: "",
      });
    } catch (error) {
      console.error(error);
      errorMessage();
    }
  };

  const handleExitModalEdit = () => {
    setIsModalEdit(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      description: "",
      newIdea: "",
      namePodcast: "",
    });
  };

  if (!prospect) {
    return null;
  }

  return (
    <AnimatePresence>
      {isModalEdit && (
        <motion.div
          key="modal-background"
          onClick={() => handleExitModalEdit()}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg p-6 font-poppina w-[500px] mx-4 border border-gray-100"
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-text">
                Información del Prospecto
              </h3>
              <button
                onClick={() => setIsModalEdit(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleEditProspect}>
              <div className="space-y-4">
                <div className="flex justify-between">
                  <span className="font-medium text-text">Nombre:</span>
                  <input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="rounded"
                  />
                </div>

                <div className="flex justify-between">
                  <span className="font-medium text-text">Email:</span>
                  <input
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="rounded"
                  />
                </div>

                <div className="flex justify-between">
                  <span className="font-medium text-text">Teléfono:</span>
                  <input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="rounded"
                  />
                </div>

                <div className="flex justify-between">
                  <span className="font-medium text-text">Descripción:</span>
                  <input
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="rounded"
                  />
                </div>

                <div className="flex justify-between">
                  <span className="font-medium text-text">Nueva Idea:</span>
                  <select
                    name="newIdea"
                    value={formData.newIdea}
                    onChange={handleChange}
                    className="w-[50%]"
                  >
                    <option value={true}>Sí</option>
                    <option value={false}>No</option>
                  </select>
                </div>

                <div className="flex justify-between">
                  <span className="font-medium text-text">Podcast:</span>
                  <input
                    name="namePodcast"
                    value={formData.namePodcast}
                    onChange={handleChange}
                    className="rounded"
                  />
                </div>
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                >
                  Guardar Cambios
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}